export const formatOpenHouses = (list, showFull = false) => {
  const maxCount = 5;
  let newList = [];
  if (!showFull) {
    let counter = 0;
    newList = list
      .map(item => {
        if (counter !== maxCount) {
          return {
            date: item.date,
            my_open_house_items: item.my_open_house_items
              .map(i => {
                if (counter !== maxCount) {
                  counter += 1;
                  return i;
                }
                return null;
              })
              .filter(Boolean)
          };
        }
        return null;
      })
      .filter(Boolean);
  } else {
    newList = list;
  }
  return newList;
};
